import { UPDATE_WS, UPDATE_WS_SUCCESSFUL, UPDATE_WS_FAILED } from './actionTypes';

const initialState = {
    updateWSError: null, messageUpdateWS: null, loadingUpdateWS: false
}

const updateWS = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_WS:
            state = {
                ...state,
                loadingUpdateWS: true,
                updateWSError: null
            }
            break;
        case UPDATE_WS_SUCCESSFUL:
            state = {
                ...state,
                loadingUpdateWS: false,
                messageUpdateWS: action.payload,
                updateWSError: null
            }
            break;
        case UPDATE_WS_FAILED:
            state = {
                ...state,
                messageUpdateWS: null,
                loadingUpdateWS: false,
                updateWSError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default updateWS;